import React from 'react';

export const ChildSupportTextMax = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи;</p>
      <p>✔️підготовка позовної заяви, або заяви про видачу судового наказу;</p>
      <p>✔️формування справи для подачі в суд;</p>
      <p>✔️подача документів в суд;</p>
      <p>✔️підготовка інших процесуальних документів за необхідністю;</p>
      <p>✔️отримання рішення суду;</p>
      <p>
        ✔️підготовка документів у відділ державної виконавчої служби для
        відкриття справи по примусовому стягненню аліментів за рішенням суду.
        Дана служба стягуватиме аліменти і перераховуватиме їх вам на карту
        банку або на відділення укрпошти.
      </p>
    </>
  );
};
